<script setup lang="ts">
const { initialize, enableAnalytics, disableAnalytics } = useGtag();
const { loggedIn } = useUserSession();
const decision = ref<'granted' | 'denied' | null>(null);
const persistServer = async (granted: boolean) => {
	if (!loggedIn.value) return;
	try {
		await $fetch('/api/data/user/settings', { method: 'PUT', body: { analyticsConsentGranted: granted } });
	} catch { /* silent */ }
};
const choose = (v: 'granted' | 'denied') => {
	decision.value = v;
	localStorage.setItem('analytics_consent', v);
	const granted = v === 'granted';
	granted ? enableAnalytics() : disableAnalytics();
	persistServer(granted);
};
onMounted(async () => {
	initialize();
	if (loggedIn.value) {
		try {
			const s = await $fetch('/api/data/user/settings');
			if (s?.analyticsConsentGranted === true) {
				decision.value = 'granted';
				enableAnalytics();
				return;
			}
			if (s?.analyticsConsentGranted === false) {
				decision.value = 'denied';
				disableAnalytics();
				return;
			}
		} catch { /* ignore and fall back */ }
	}
	const stored = localStorage.getItem('analytics_consent') as 'granted' | 'denied' | null;
	if (stored) {
		decision.value = stored;
		stored === 'granted' ? enableAnalytics() : disableAnalytics();
	}
});
</script>

<template>
	<div v-if="decision === null" class="fixed bottom-[var(--ui-header-height)] z-40 w-full">
		<div class="bg-elevated border border-accented rounded text-xs m-2 p-2 flex gap-3 items-center justify-between">
			<span class="grow truncate">Optional anonymous analytics (no personal data). Allow usage data to help us
				improve?</span>
			<div class="flex gap-2 shrink-0">
				<UButton size="xs" variant="ghost" color="neutral" label="Reject" @click="choose('denied')" />
				<UButton size="xs" color="primary" label="Accept" @click="choose('granted')" />
			</div>
		</div>
	</div>
</template>
